import type { ReactNode } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type Ics204DisabledActionTooltipProps = {
  reason: string;
  children: ReactNode;
};

/**
 * Wraps a disabled control so hover still shows why it cannot be used (native
 * disabled buttons do not receive pointer events).
 */
export function Ics204DisabledActionTooltip({
  reason,
  children,
}: Ics204DisabledActionTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          render={
            <span className="tw:inline-flex tw:cursor-not-allowed">
              {children}
            </span>
          }
        />
        <TooltipContent side="top" className="tw:max-w-xs">
          {reason}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
